
  import { Component, Vue, Watch } from "vue-property-decorator";
  import { RankingList, StatisticalData, deviceStatus } from "@/views/components";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import Scan from "@/views/components/Scan/Scan.vue";
  import config from "./config";
  import Form1 from "./Form1.vue";
  import Form2 from "./Form2.vue";
  import FormPic from "./FormPic.vue";
  import TableHeader from "./TableHeader.vue";

  @Component({
    name: "scanforgeton",
    components: {
      deviceStatus,
      RankingList,
      StatisticalData,
      YtoTable,
      Form1,
      Form2,
      TableHeader,
      Scan,
      FormPic,
    },
  })
  export default class extends Vue {
    private inputModel: inputDataModel_SixScan = {
      checked_NeedWeight: true,
      checked_NeedVolumn: false,
      input_ScanCode: "",
      input_TrueThingCode: "",
    };
    @Watch("inputModel", { deep: true })
    onChildChanged(val: string) {
      this.asyncSendDataToNet(val);
    }

    mounted() {
      //初始化设备状态
      this.deviceItems = [];
      for (let index = 1; index <= 12; index++) {
        this.deviceItems.push({
          name: "设备" + index.toString(),
          title: index.toString(),
          status: "defult",
        });
      }

      //初始化统计数据栏目内显示的数据
      this.statisticalList = [{ label: "总扫描数", value: "0", combine: "1" }];

      try {
        //注册设备状态回调函数
        obj_ScanForSixScan.regist_getdevicestate(this.getdevicestatecallback);
        obj_ScanForSixScan.regist_datahistorycallback(this.datahistorycallback);
        obj_ScanForSixScan.regist_errormsgcallback(this.errormsgcallback);
        obj_ScanForSixScan.regist_statisticaldata(this.statisticaldatacallback);
        obj_ScanForSixScan.regist_updateformdata(this.scanareacallback);
        obj_ScanForSixScan.regist_ranklistupdate(this.ranklistupdatecallback);
        console.log("上车界面:注册回调函数完成");
        console.log("六面扫描界面:注册回调函数完成");
      } catch (error) {
        console.log("上车界面:注册回调函数异常" + error);
        console.log("六面扫描界面:注册回调函数异常" + error);
      }
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    }
    public ranklistdata: rankListModel = {
      avgEfficiency: "0",
      lastHourAvgEfficiency: "0",
      avgEfficiencyRank: "0",
      frequencyRank: "0",
      wholeTopEfficiency: "0",
    };
    //Form1界面回调
    public ranklistupdatecallback(dic) {
      console.log("Vue接受客户端传来的排行榜数据");
      console.log(dic);
      this.ranklistdata = dic;
      console.log("个人排行榜数据接收");
      console.log(this.ranklistdata);
    }

    public asyncSendDataToNet(data) {
      console.log("[上车]Vue界面参数传递成功1：");
      // return new Promise((resolve, reject) => {
      return new Promise(() => {
        var result = obj_ScanForSixScan.sendformdataaction(data);
        console.log("[上车]Vue界面参数传递成功：" + result);
      });
    }
    //上传成功,为黑色，其他都是红色
    private rowClassAction(row) {
      if (/失败/.test(row.row.UploadStateName)) {
        return { color: "#f22613", "font-size": "130%", "font-weight": "bold" };
      }
    }
    private getFormValue(element) {
      console.log("父组件接受子组件Form1传来的数据");
      console.log(element);
      this.inputModel = element;
    }
    private getForm2Value(element) {
      console.log("父组件接受子组件Form2传来的数据");
      this.inputModel.checked_NeedWeight = element.checked_NeedWeight;
      this.inputModel.checked_NeedVolumn = element.checked_NeedVolumn;
      console.log(this.inputModel);
    }
    private currentRowChanged(element) {
      console.log("父组件接受子组件传来的数据currentrow");
      console.log(element);
      this.currentrow = element;
      console.log("______________________");
      console.log(element.code);
      this.inputModel.input_TrueThingCode = element.code;
      this.callbackmodel=this.inputModel;
    }
    //获得焦点，选中文本
    private getInputFocus(event): void {
      event.currentTarget.select();
    }
    //更新设备状态数据
    public getdevicestatecallback(datas): void {
      console.log("设备状态");
      console.log(datas);
      this.deviceItems = [];
      this.deviceItems = datas;
      console.log(this.deviceItems);
    }
    public index = 1;
    //更新数据列表的数据
    public datahistorycallback(data) {
      console.log(data);
      console.log("C#列表回传方法");
      var index = data.Value;
      this.showList = [];
      for (let _index = 0; _index < data.Key.length; _index++) {
        var element = data.Key[_index];
        this.showList.push({
          index: index,
          code: element.strCode,
          ScanTime: element.ScanTime,
          Info: element.UploadStateName,
        });
        index--;
      }
    }
    //错误消息回调显示方法
    public errormsgcallback(data) {
      this.errormessage = data;
    }
    //统计数据回显
    public statisticaldatacallback(data) {
      console.log("统计数据回显");
      console.log(data);
      data.forEach((element) => {
        console.log(element);
        if (element.Key == "totalScanCount") {
          this.statisticalList[0].value = element.Value;
          console.log("totalScanCount:" + element.Key + "|" + element.Value);
        }
      });

      console.log(this.statisticalList);
    }
    public msg = "";
    private config = config;
    private statisticalList = [];
    public currentrow = null;
    public showList = [];
    public ytoCode = "";
    //扫描区扫码
    private ytocodeget() {
      console.log("|FUNC|Input_ScanArea_Click");
      console.log(this.ytoCode);
      this.inputModel.input_ScanCode = this.ytoCode.toUpperCase();
      // }
      try {
        obj_ScanForSixScan.scanArea_Click(this.inputModel, this.scanareacallback);
        console.log("|FUNC|Input_ScanArea_Click发送给C#");
      } catch (error) {
      }
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    }
    public callbackmodel = {};
    //界面参数更新方法
    private scanareacallback(backdata): void {
      this.callbackmodel = backdata;
      console.log("回传参数赋值");
      console.log(this.callbackmodel);
      this.inputModel.input_ScanCode = "";
      if (backdata == null) {
        return;
      }
      //更新录入区域
      //更新实物条码
      if (
        backdata.input_TrueThingCode != null &&
        this.inputModel.input_TrueThingCode != backdata.input_TrueThingCode
      ) {
        this.inputModel.input_TrueThingCode = backdata.input_TrueThingCode;
      }

      //更新扫描条码
      if (
        backdata.input_ScanCode != null &&
        this.inputModel.input_ScanCode != backdata.input_ScanCode
      ) {
        this.inputModel.input_ScanCode = backdata.input_ScanCode;
      }
    }

    public selectElementContents(el) {
      console.log("|FUNC|selectElementContents");
      //失去焦点，获取焦点
      el.blur();
      el.focus();
    }
    private deviceItems: deviceItem[] = [];
    private errormessage = "";
    private currentRow = null;
    private tableshow = true;
  }
